import { motion } from 'motion/react';
import styles from './Prize.module.css';

import box from 'assets/images/box.png';
import box1 from 'assets/images/box1.png';
import box2 from 'assets/images/box2.png';

export const Prize = ({ questionImgUrl }) => {
  const prize = questionImgUrl || box;

  const errorHandler = (e) => {
    e.target.src = box;
  };

  return (
    <div className={styles.prizeWrapper}>
      <div className={styles.prizeBlock}>
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.8 }}
          className={styles.circle1}
        />
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.44, delay: 0.56 }}
          className={styles.circle2}
        />

        <motion.div
          key={questionImgUrl}
          className={styles.prize}
          initial={{ scale: 0 }}
          animate={{ scale: questionImgUrl ? 1 : 0.8 }}
          transition={{ duration: 1.44, delay: 1.12 }}
          exit={{ scale: 0 }}
        >
          <img src={prize} alt="" onError={errorHandler} />
        </motion.div>

        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.44, delay: 1.12 }}
          className={styles.shadowPrize}
        />

        <motion.div
          className={styles.box1}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1, delay: 0.88 }}
          exit={{ scale: 0 }}
        >
          <img src={box1} alt="" />
        </motion.div>

        <motion.div
          className={styles.box2}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1, delay: 1 }}
          exit={{ scale: 0 }}
        >
          <img src={box2} alt="" />
        </motion.div>
      </div>
    </div>
  );
};
